import React, {useState,useEffect} from "react";
import Swal from "sweetalert2";
import {useParams} from "react-router-dom"
// import {useNavigate} from "react-router-dom"
// import { Link } from "react-router-dom";

// SERVICES
import fundService from "../../services/fundService";

function ManagementCompanyApproval() {
  
    // const navigate = useNavigate();
    const {fundOperationId} = useParams();
    const [sending, setSending] = useState(false)
    
    useEffect(() => { doLoad(); }, []);
    
    const doLoad = async () => {
        try {
            setSending(true);
            await fundService.getManagementCompanySign({"fund_operation_id": fundOperationId});
            Swal.fire({
                title: 'Aprobación exitosa',
                text: 'La operación fue aprobada correctamente.',
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#396bad'
            });
        } catch (error) {
            Swal.fire({
                title: 'ERROR',
                text: error?.response?.data?.errors?.[0]?.detail ?? 'Ocurrió un error al procesar la solicitud.',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#f13939'
            });
        } finally {
            setSending(false);
        }
    }

    return (
        <div>
            <div className="container-fluid flex-grow-1 container-p-y">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-center">
                            <img src="/alchemy-logo.svg" alt="alchemy valores logo" className="img-fluid mb-4" style={{width: '15%'}}/>
                        </div>
                    </div>
                    {
                        sending ? (
                            <div className="d-flex justify-content-center">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <>
                               
                            </>
                        )
                    }
                </div>
            </div>
            {/* GLOBEMIND */}
            <footer style={{textAlign: 'right', marginRight: 20,fontSize: 'small', marginTop: '-25px'}}>
                Power by <a href="https://globemind.com/" target="_blank" style={{color: '#396bad'}} rel="noreferrer" title="GlobeMind Software Distillery">GlobeMind</a>
            </footer>
        </div>        
      );
}

  
export default ManagementCompanyApproval;